import { getWindowLocationValues } from './helpers'

/**
 * Track form enter events
 *
 * @param {object} statsigClient
 * @param {object} event
 * @param {string} event.toStepId
 * @param {object} event.scope
 */
export function trackFormEnterEvent(statsigClient, { toStepId, scope }) {
  statsigClient?.logEvent('form_enter', toStepId, {
    to_step_id: toStepId,
    form_id: scope?.form_id,
    form_entry_point: scope?.form_entry_point,
    ...getWindowLocationValues(scope),
  })
}
